import { styled } from '@mui/material/styles';

const StyledAgentAvatar = styled('div')`
  display: flex;
  align-items: center;
  gap: 1rem;

  &:hover {
    cursor: pointer;
  }

  & img {
    border-radius: 50%;
  }

  & span {
    flex-grow: 1;
  }
`;

export default StyledAgentAvatar;
